import { render, staticRenderFns } from "./FirstInitIM.vue?vue&type=template&id=1fb9dc04&scoped=true"
import script from "./FirstInitIM.vue?vue&type=script&lang=js"
export * from "./FirstInitIM.vue?vue&type=script&lang=js"
import style0 from "./FirstInitIM.vue?vue&type=style&index=0&id=1fb9dc04&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fb9dc04",
  null
  
)

export default component.exports